import React from "react";
import { Truck } from "lucide-react";

const THRESHOLD = parseFloat(process.env.REACT_APP_FREE_SHIPPING_THRESHOLD || "50");

/**
 * Shows a progress bar toward free shipping.
 * - `subtotal` (required) — current cart subtotal
 * - `threshold` (optional) — override default $50
 * - `compact` (optional) — smaller variant for cart drawer
 * Returns null if cart is empty.
 */
export default function FreeShippingBar({ subtotal = 0, threshold, compact = false }) {
  const goal = threshold ?? THRESHOLD;
  if (!subtotal || goal <= 0) return null;

  const unlocked = subtotal >= goal;
  const remaining = Math.max(goal - subtotal, 0);
  const pct = Math.min((subtotal / goal) * 100, 100);

  return (
    <div
      className={`rounded-xl border ${unlocked ? "border-primary/40 bg-primary/10" : "border-white/10 bg-secondary/30"} ${compact ? "p-3" : "p-4"}`}
      data-testid="free-shipping-bar"
    >
      <div className="flex items-center gap-2 mb-2">
        <Truck className={`h-4 w-4 ${unlocked ? "text-primary" : "text-muted-foreground"}`} />
        <p className={`text-sm ${unlocked ? "font-semibold text-primary" : "text-foreground"}`} data-testid="free-shipping-message">
          {unlocked
            ? "You've unlocked free standard shipping"
            : <>Add <span className="font-semibold text-primary">${remaining.toFixed(2)}</span> more for free shipping</>}
        </p>
      </div>
      <div className="h-1.5 rounded-full bg-white/5 overflow-hidden">
        <div
          className="h-full bg-primary transition-all duration-500 ease-out"
          style={{ width: `${pct}%` }}
          data-testid="free-shipping-progress"
        />
      </div>
    </div>
  );
}
